/**
 * Errors Module
 * Error display utilities for forms
 */

export interface ErrorResponse {
    message?: string;
    responseJSON?: Record<string, string>;
    responseText?: string;
}

export function findErrorBlock(currentModal: string | null, errorBlockClass: string): HTMLElement | null {
    if (currentModal) {
        const modal = document.querySelector(currentModal);
        
        if (modal) {
            return modal.querySelector<HTMLElement>(errorBlockClass);
        }
        
        return null;
    }

    const errorBlocks = document.querySelectorAll<HTMLElement>(errorBlockClass);
    
    if (errorBlocks.length > 0) {
        return errorBlocks[0];
    }

    return null;
}

export function populateErrorBlock(
    errorBlock: HTMLElement | null,
    response: ErrorResponse,
    scrollOnError: boolean = true
): boolean {
    if (!errorBlock) {
        return false;
    }

    if (typeof response.message !== 'undefined') {
        const errMsg = `<span class="d-block">${response.message}</span>`;
        errorBlock.insertAdjacentHTML('beforeend', errMsg);
    } else {
        const errorData = response.responseJSON;

        if (errorData) {
            for (const field in errorData) {
                if (Object.prototype.hasOwnProperty.call(errorData, field)) {
                    const errMsg = `<span class="d-block">${errorData[field]}</span>`;
                errorBlock.insertAdjacentHTML('beforeend', errMsg);
                }
            }
        }
    }

    errorBlock.classList.add('ui-state-error');
    errorBlock.classList.remove('d-none');
    errorBlock.setAttribute('role', 'alert');

    if (scrollOnError) {
        scrollToError(errorBlock);
    }

    return true;
}

export function populateErrorUnderInput(form: HTMLFormElement, response: ErrorResponse): void {
    const errorData = response.responseJSON;

    if (!errorData) {
        return;
    }

    for (const field in errorData) {
        if (Object.prototype.hasOwnProperty.call(errorData, field)) {
            const input = form.querySelector<HTMLInputElement>('#' + field);

            if (input) {
                form.classList.add('was-validated');
                let feedback = input.parentElement?.querySelector('.invalid-feedback');
                
                if (!feedback) {
                    feedback = form.querySelector('#' + field + ' ~ .invalid-feedback');
                }

                if (feedback) {
                    feedback.textContent = errorData[field];
                }

                input.setCustomValidity(errorData[field]);
            }
        }
    }
}

export function showPhoneError(elem: HTMLElement, message: string): void {
    const parent = elem.parentElement;

    if (parent) {
        const errorDiv = parent.querySelector<HTMLElement>('.intl-tel-input-validation.invalid-feedback');

        if (errorDiv) {
            errorDiv.textContent = message;
        }
    }
}

export function clearErrorBlock(errorBlock: HTMLElement | null): void {
    if (errorBlock) {
        errorBlock.classList.add('d-none');
        errorBlock.classList.remove('ui-state-error');
        errorBlock.removeAttribute('role');
        errorBlock.innerHTML = '';
    }
}

export function scrollToError(errorBlock: HTMLElement): void {
    const rect = errorBlock.getBoundingClientRect();
    const errorTop = rect.top + window.scrollY - 150;
    
    window.scrollTo({ top: errorTop, behavior: 'smooth' });
}